/**
 * Unset (`undefined`) means "use the first importable store".
 * `null` is the explicit "None" choice.
 */
export function resolveImportShopifyIntegrationId({
  selectedId,
  importableIntegrationIds,
}: {
  selectedId: string | null | undefined;
  importableIntegrationIds: readonly string[];
}): string | null {
  if (selectedId === null) {
    return null;
  }
  if (
    selectedId !== undefined &&
    importableIntegrationIds.includes(selectedId)
  ) {
    return selectedId;
  }
  return importableIntegrationIds[0] ?? null;
}
